import axios from "axios";
import { serviceUrl } from "../../config";
import { checkSessionIsActive, getSessionData } from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";

const BACKEND_URL = serviceUrl;

export const bpiAPI = async (formdata, serviceName, additionalParams) => {
    const sessionData = getSessionData();
    try {
      const data = JSON.stringify({
        svc: "BPI",
        pid: serviceName,
        dat: {
          ...formdata,
          ...sessionData,
          ...additionalParams
        }
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      const sessionActive = checkSessionIsActive(response.data);
      if (!sessionActive) {
        resetSession();
      }
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const bpiTrackTransaction = async (refNumber) => {
    try {
      const data = JSON.stringify({
        svc: "BPI",
        pid: "BpiGetTransactionStatus",
        dat: {
          location: "",
          nonce: refNumber
        }
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const bpiGetBanks = async () => {
    try {
      const data = JSON.stringify({
        svc: "BPI",
        pid: "bpiGetBanks",
        dat: {
          location: ""
        }
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };